import { render, staticRenderFns } from "./data80.vue?vue&type=template&id=4e6f6b15&scoped=true"
import script from "./data80.vue?vue&type=script&lang=js"
export * from "./data80.vue?vue&type=script&lang=js"
import style1 from "./data80.vue?vue&type=style&index=1&id=4e6f6b15&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6f6b15",
  null
  
)

export default component.exports